import React, { useState } from "react";
import {
  RiCloseLine,
  RiMapPinLine,
  RiCheckLine,
  RiArrowRightLine,
  RiTimeLine,
  RiMapPinTimeLine,
} from "react-icons/ri";

const BusBoardingPoints = ({ bus, onClose, onSubmit, autoProceed = false }) => {
  const [selectedBoarding, setSelectedBoarding] = useState(null);
  const [selectedDropping, setSelectedDropping] = useState(null);

  const handleSubmit = () => {
    if (selectedBoarding && selectedDropping) {
      onSubmit(selectedBoarding, selectedDropping);
    }
  };

  const handleBoardingSelect = (point) => {
    setSelectedBoarding(point);
  };

  const handleDroppingSelect = (point) => {
    setSelectedDropping(point);
  };

  // Mock boarding and dropping points with enhanced data
  const boardingPoints = bus.boardingPoints || [
    {
      id: "bp1",
      location: "Mumbai Central",
      time: "22:00",
      pointName: "Mumbai Central Bus Stand",
      landmark: "Near Railway Station",
      address: "Mumbai Central, Mumbai, Maharashtra 400008",
      distance: "0 km",
      facilities: ["Waiting Lounge", "Food Court", "Restrooms"],
    },
    {
      id: "bp2",
      location: "Andheri",
      time: "22:30",
      pointName: "Andheri Bus Stop",
      landmark: "Near Metro Station",
      address: "Andheri East, Mumbai, Maharashtra 400069",
      distance: "15 km",
      facilities: ["Parking", "ATM"],
    },
    {
      id: "bp3",
      location: "Bandra",
      time: "23:00",
      pointName: "Bandra Bus Depot",
      landmark: "Opposite Bandra Station (W)",
      address: "Bandra West, Mumbai, Maharashtra 400050",
      distance: "25 km",
      facilities: ["Waiting Area", "Food Stalls"],
    },
  ];

  const droppingPoints = bus.droppingPoints || [
    {
      id: "dp1",
      location: "Pune Station",
      time: "06:00",
      pointName: "Pune Railway Station",
      landmark: "Near Shivajinagar",
      address: "Pune Station, Pune, Maharashtra 411001",
      distance: "0 km",
      facilities: ["Auto/Taxi Stand", "Restaurants"],
    },
    {
      id: "dp2",
      location: "Swargate",
      time: "06:30",
      pointName: "Swargate Bus Stand",
      landmark: "Main Bus Terminal",
      address: "Swargate, Pune, Maharashtra 411042",
      distance: "5 km",
      facilities: ["Bus Connections", "Shopping"],
    },
    {
      id: "dp3",
      location: "Hinjewadi",
      time: "07:00",
      pointName: "Hinjewadi IT Park",
      landmark: "Phase 1, Near Tech Park",
      address: "Hinjewadi, Pune, Maharashtra 411057",
      distance: "25 km",
      facilities: ["Corporate Drop", "Taxi Service"],
    },
  ];

  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  return (
    <div className="bus-modal-overlay">
      <div className="bus-modal-content bus-boarding-points-modal">
        <div className="bus-modal-header">
          <h5 className="bus-modal-title">
            <RiMapPinLine className="me-2" />
            Select Boarding & Dropping Points
          </h5>
          <button type="button" className="bus-btn-close" onClick={onClose}>
            <RiCloseLine />
          </button>
        </div>

        <div className="bus-modal-body">
          <div className="row g-4">
            {/* Boarding Points */}
            <div className="col-lg-6">
              <div className="bus-boarding-section">
                <h6 className="bus-section-title">
                  <RiMapPinTimeLine className="me-2 text-primary" />
                  Select Boarding Point
                  {selectedBoarding && (
                    <RiCheckLine className="text-success ms-2" />
                  )}
                </h6>
                <div className="bus-points-list">
                  {boardingPoints.map((point) => (
                    <div
                      key={point.id}
                      className={`bus-point-card ${
                        selectedBoarding?.id === point.id
                          ? "bus-point-card-selected"
                          : ""
                      }`}
                      onClick={() => handleBoardingSelect(point)}
                    >
                      <div className="d-flex align-items-start w-100">
                        <div className="form-check me-3 mt-1">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="boardingPoint"
                            checked={selectedBoarding?.id === point.id}
                            onChange={() => handleBoardingSelect(point)}
                          />
                        </div>
                        <div className="bus-point-info">
                          <div className="d-flex justify-content-between align-items-start">
                            <strong>{point.pointName}</strong>
                            <span className="badge bg-primary ms-2">
                              {point.distance}
                            </span>
                          </div>
                          <div className="bus-point-time">
                            <RiTimeLine className="me-1" />
                            Boarding Time: {formatTime(point.time)}
                          </div>
                          <div className="bus-point-address mb-2">
                            {point.address}
                          </div>
                          {point.landmark && (
                            <div className="text-muted small mb-1">
                              <strong>Landmark:</strong> {point.landmark}
                            </div>
                          )}
                          {point.facilities && point.facilities.length > 0 && (
                            <div className="small">
                              <strong>Facilities:</strong>{" "}
                              {point.facilities.join(", ")}
                            </div>
                          )}
                        </div>
                      </div>
                      {selectedBoarding?.id === point.id && (
                        <RiCheckLine className="text-success bus-selected-check ms-2" />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Dropping Points */}
            <div className="col-lg-6">
              <div className="bus-boarding-section">
                <h6 className="bus-section-title">
                  <RiMapPinTimeLine className="me-2 text-success" />
                  Select Dropping Point
                  {selectedDropping && (
                    <RiCheckLine className="text-success ms-2" />
                  )}
                </h6>
                <div className="bus-points-list">
                  {droppingPoints.map((point) => (
                    <div
                      key={point.id}
                      className={`bus-point-card ${
                        selectedDropping?.id === point.id
                          ? "bus-point-card-selected"
                          : ""
                      }`}
                      onClick={() => handleDroppingSelect(point)}
                    >
                      <div className="d-flex align-items-start w-100">
                        <div className="form-check me-3 mt-1">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="droppingPoint"
                            checked={selectedDropping?.id === point.id}
                            onChange={() => handleDroppingSelect(point)}
                          />
                        </div>
                        <div className="bus-point-info">
                          <div className="d-flex justify-content-between align-items-start">
                            <strong>{point.pointName}</strong>
                            <span className="badge bg-success ms-2">
                              {point.distance}
                            </span>
                          </div>
                          <div className="bus-point-time">
                            <RiTimeLine className="me-1" />
                            Dropping Time: {formatTime(point.time)}
                          </div>
                          <div className="bus-point-address mb-2">
                            {point.address}
                          </div>
                          {point.landmark && (
                            <div className="text-muted small mb-1">
                              <strong>Landmark:</strong> {point.landmark}
                            </div>
                          )}
                          {point.facilities && point.facilities.length > 0 && (
                            <div className="small">
                              <strong>Facilities:</strong>{" "}
                              {point.facilities.join(", ")}
                            </div>
                          )}
                        </div>
                      </div>
                      {selectedDropping?.id === point.id && (
                        <RiCheckLine className="text-success bus-selected-check ms-2" />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Selected Points Summary */}
          {(selectedBoarding || selectedDropping) && (
            <div className="bus-selected-summary mt-4 p-3 bg-light rounded">
              <h6 className="d-flex align-items-center mb-3">
                <RiCheckLine className="text-success me-2" />
                Selected Points Summary
              </h6>
              <div className="row">
                {selectedBoarding && (
                  <div className="col-md-6">
                    <div className="bus-summary-item">
                      <strong className="d-block mb-1">Boarding Point:</strong>
                      <div className="d-flex align-items-center">
                        <RiMapPinLine className="text-primary me-2" />
                        <div>
                          <div>{selectedBoarding.pointName}</div>
                          <small className="text-muted">
                            {formatTime(selectedBoarding.time)} •{" "}
                            {selectedBoarding.address}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {selectedDropping && (
                  <div className="col-md-6">
                    <div className="bus-summary-item">
                      <strong className="d-block mb-1">Dropping Point:</strong>
                      <div className="d-flex align-items-center">
                        <RiMapPinLine className="text-success me-2" />
                        <div>
                          <div>{selectedDropping.pointName}</div>
                          <small className="text-muted">
                            {formatTime(selectedDropping.time)} •{" "}
                            {selectedDropping.address}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="bus-modal-footer">
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary d-flex align-items-center"
            disabled={!selectedBoarding || !selectedDropping}
            onClick={handleSubmit}
          >
            Confirm Points
            <RiArrowRightLine className="ms-2" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusBoardingPoints;
